import React from 'react';
import LeadForm from '../components/LeadForm';
import { useSeo } from '../seo/useSeo';
import SEO_PAGES from '../seo/pages.json';

const ContactPage = () => {
  useSeo({ ...SEO_PAGES['/contact'], canonicalPath: '/contact' });

  return (
    <div className="contact-page">
      <header className="contact-page-header">
        <p className="offering-feature-eyebrow">Get In Touch</p>
        <h1>Check Availability</h1>
        <p className="contact-page-intro">
          Tell us about your event and we&rsquo;ll confirm availability and get back to you with next steps. Questions first? Call us at <a href="tel:+19132389020">(913) 238-9020</a> or email{' '}
          <a href="mailto:contact@discoduckevents.com">contact@discoduckevents.com</a>.
        </p>
      </header>

      <section className="contact-page-form" id="booking-form">
        <LeadForm />
      </section>
    </div>
  );
};

export default ContactPage;
